import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';
import { Button } from '../../../components/ui/index.jsx';
import { useToast } from '../../../components/ui/Toast.jsx';

const TranslationsTab = () => {
    const toast = useToast();
    const [originalTranslationSettings, setOriginalTranslationSettings] = useState({});
    const [translationSettings, setTranslationSettings] = useState({});
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const global = window.BPSFW_GLOBAL_OPTIONS || {};
        setTranslationSettings(global);
        setOriginalTranslationSettings(global);
    }, []);

    const handleSave = () => {
        const changedData = {};
    
        Object.entries(translationSettings).forEach(([key, value]) => {
            if (String(originalTranslationSettings[key]) !== String(value)) {
                changedData[key] = value;
            }
        });
    
        if (Object.keys(changedData).length === 0) {
            toast.info('No changes detected.');
            return;
        }
    
        setLoading(true);
    
        apiFetch({ path: '/wp/v2/settings', method: 'POST', data: changedData })
        .then(() => {
            toast.success('General settings saved successfully!');
            window.BPSFW_GLOBAL_OPTIONS = {
                ...(window.BPSFW_GLOBAL_OPTIONS || {}),
                ...translationSettings
            };
            setOriginalTranslationSettings(translationSettings);
        })
        .catch((err) => {
            console.error('Error saving translation settings:', err);
            toast.error('Error saving translation settings.');
        })
        .finally(() => setLoading(false));
    };

    const updateTranslationSetting = (key, value) => setTranslationSettings(prev => ({ ...prev, [key]: value }));
    const Roles = window.BPSFW_GLOBAL_ROLES || {};

    return (
        <div className="plugin-notification-setting-tab">
            {loading && (
                <div className="bpsfw-overlay-loader">
                    <div className="bpsfw-loader-box">
                        <div className="bpsfw-spinner"></div>
                        <span className="bpsfw-loader-text">Saving changes…</span>
                    </div>
                </div>
            )}

            <div className="bpsfw-section-card">
                <div className="bpsfw-section-header">
                    <div className="bpsfw-section-icon">🌐</div>
                    <div>
                        <div className="bpsfw-section-title">Translation Settings</div>
                        <div className="bpsfw-section-subtitle">Custom translations for various texts</div>
                    </div>
                </div>
                <div className="bpsfw-section-body">
                    
                    {renderInputRow('Login to see prices text', 'bpsfw_login_to_see_price', '', [], '', '', translationSettings, updateTranslationSetting)}

                    {renderInputRow('Login Form Title', 'bpsfw_login_form_title', '', [], '', '', translationSettings, updateTranslationSetting)}
                    {renderInputRow('Registration Form Title', 'bpsfw_registration_form_title', '', [], '', '', translationSettings, updateTranslationSetting)}
                    {renderInputRow('Registration Successful Message', 'bpsfw_registration_successful_message', '', [], '', '', translationSettings, updateTranslationSetting)}
                    
                </div>
            </div>

            <div className="bpsfw-save-row">
                <Button variant="primary" onClick={handleSave}>Save Changes</Button>
            </div>
        </div>
    );
};

export default TranslationsTab;